(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const expandableTitles = document.querySelectorAll('.expandable-title');
  expandableTitles.forEach(function(title) {
    console.log('Adding event listener to:', title); // Log when adding the event listener
    title.addEventListener('click', function() {
      console.log('Title clicked:', title); // Log when the title is clicked
      const description = title.nextElementSibling;
      console.log('Description element:', description); // Log the description element
      if (description.classList.contains('hidden')) {
        console.log('Removing hidden class'); // Log when removing the hidden class
        description.classList.remove('hidden');
        title.classList.add('open'); // Add open class to rotate the arrow
      } else {
        console.log('Adding hidden class'); // Log when adding the hidden class
        description.classList.add('hidden');
        title.classList.remove('open'); // Remove open class to rotate the arrow back
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
      })();
